import { gql } from '@apollo/client';

export const GET_CONSULTATION = gql`
  query GetConsultation($id: ID!) {
    consultation: getConsultation(id: $id) {
      id
      createdAt
      date
      time
      startTime
      endTime
      issue
      visitType
      seenBy {
        id
        firstName
        lastName
      }
      status
      flagged
      reasonForFlagging
      approved
      treatedBefore
      photoIdCopy
      height
      weight
      bloodPressureTop1
      bloodPressureTop2
      bloodPressureBottom1
      bloodPressureBottom2
      pulseRate
      respiratoryRate
      oxygenSaturation
      bodyTemperature
      glucose
      hemoglobin
      urineDipstick
      urineDrugTest
      preganancyTest
      preganancyResult
      bmiAbove25
      smoking
      alcoholUse
      mentalIssues
      tbScreen
      tbNaatTest
      tbSputumForAfb
      tbManagementStatus
      stiScreen
      stiManagement
      vds
      mus
      lap
      gw
      ssw
      rpr
      rprResults
      hivTest
      hivResults
      hivDiscordant
      allergiesPresent
      allergyDetails
      subjectiveNotesComplaints
      serviceNotesComplaints
      objectiveNotes
      assessmentNotes
      planOrProgressNotes
      rxFilled
      rx
      rxDispensed
      rxConfirmation
      referrals
      isARTClient
      regimen
      internalReferral
      doctorReferral
      ancFotdReferral
      caseworkerReferral
      schoolCaseworkerReferral
      psychologistReferral
      dieticianReferral
      externalReferral
      localClinicReferral
      clinicReferral
      hospitalReferral
      imagingRadiologyReferral
      dentistReferral
      audiologistReferral
      gynaecologicalReferral
      mammogramReferral
      colonoscopyReferral
      otherHealthPractitionersReferral
      practitionersReferral
      otherServiceProvidersReferral
      serviceProvidersReferral
      followUpAppointment
      infantAssessmentClinical {
        id
        diagnosisType
        headCircumference
        coughDurationDays
        diarrhoeaDurationDays
        feverDurationDays
        earDischargeDurationDays
        breastfeedingFrequency
        otherFoodDrinksFrequency
        careAnotherFacilityDetails
        fluidsGivenByCaregiver
        feedingMethod
        babyJustDelivered
        receivedCareAnotherFacility
        oedemaBothFeet
        feverPresent
        convulsionsCurrentIllness
        bulgingFontanelle
        signsSymptomsCongenitalTb
        motherOnTbTreatment
        admittedHospitalPostDelivery
        generalDangerSignPresent
        notAbleToDrinkBreastfeed
        vomitsEverything
        coughDifficultBreathing
        fastBreathing
        chestIndrawing
        stridor
        wheeze
        wheezeBeforeIllness
        wheezeMoreThan7Days
        asthmaTreatmentPresent
        nasalFlaringOrGrunting
      }
      infantAssessmentScreening {
        id
        diarrhoeaPresent
        bloodInStool
        veryYoungInfantUnderOneMonth
        restlessOrIrritable
        malariaRisk
        measlesSuspectedPresent
        earProblemPresent
        measlesFever
        measlesRash
        runnyNoseCoughRedEyes
        contactWithMeasles
        measlesPneumonia
        symptomaticHivInfection
        corneaClouded
        deepMouthUlcers
        eyesDrainingPus
        earPain
        pusSeenDrainingEar
        wakesChildAtNight
        earDischargeReported
        tenderSwellingBehindEar
        soreThroatPresent
        scarlatiniformRash
        enlargedTonsils
        tonsillarExudate
        breastfeeding
        feedingDifficulties
        receivingOtherFoodDrinks
        pcrTest
        oralThrush
        hivTestMother
        lowWeightForAge
        closeTbContact
        tbCoughTwoWeeks
        fullTbAssessmentRequired
        tbLossWeight
        tbFeverFor7Days
        tbNotGrowingWell
        parotidEnlargement
        apnoea
        pusDrainingEye
        umbilicalRedness
        feverOrLowTemperature
        onlyMovesWhenStimulated
        stickyEyeDischarge
        umbilicalRednessExtendsToSkin
        skinPustulesPresent
        skinPustulesManySevere
        jaundiceBefore24Hours
        jaundiceAfter24Hours
        yellowPalmsSoles
        cleftLipOrPalate
        microcephaly
        imperforateAnus
        ambiguousGenitalia
        abdominalDistension
        noseNotPatent
        macrocephaly
        clubFoot
        fontanelleSuturesAbnormal
        swellingScalpHeadShapeAbnormal
        otherCongenitalProblems
        weightStatus
        muacCategory
        weightForHeightLength
        skinPinch
        malariaTestResult
        pallorSeverity
        pcrResults
        hivResultsMother
        motherRprResult
        motherSyphilisTreatmentStatus
      }
      infantAssessmentExtended {
        id
        birthWeightLessThan2kg
        knownNeurologicalCongenitalProblem
        lethargicOrUnconscious
        frequentCoughAtNight
        mouthUlcers
        pneumoniaNow
        unsatisfactoryWeightGain
        persistentDiarrhoeaNowPast3Months
        earDischargeNowOrPast
        enlargedGlandsIn2OrMore
        veryLowBirthWeightLe2kg
        neckSwellingsWebbing
        faceEyesMouthNoseAbnormal
        unusualAppearance
        abnormalPositionLimbs
        abnormalFingersToesPalms
        abnormalChestBackAbdomen
        undescendedTestisHernia
        immunisationSummary
        immunisationStatus
        immunisationAction
        nextImmunisationDate
        respiratoryRateRepeat
        sunkenEyes
        stiffNeck
        feedingAssessmentRequired
        soreThroatRunnyNose
        soreThroatCough
      }
      routineTreatments {
        id
        prescriptionDate
        vitaminA
        mebendazole
        nextPrescriptionDate
      }
      immunisation {
        bcg
        opv0
        daptIpvHbHib1
        opv1
        pcv1
        rv1
        daptIpvHbHib2
        daptIpvHbHib3
        rv2
        pcv2
        measles1
        pcv3
        measles2
        daptIpvHbHib4
        td6Years
        td12Years
        hpv
        immunisationStatus
        nextImmunisationDate
        immunisationService
      }
      attachment {
        id
        url
        name
      }
      medicationLabel {
        id
        url
        name
      }
      activity {
        id
        name
        requiresReview
        flagReview
      }
      appointments {
        id
        date
        time
        notes
        description
        followUpAppointment
        status
        practitioner {
          id
          firstName
          lastName
        }
        consultationTypes {
          id
          name
        }
        consultation {
          id
        }
        categories {
          id
          name
        }
      }
      linkedAppointments {
        id
        date
        time
        notes
        description
        followUpAppointment
        status
        practitioner {
          id
          firstName
          lastName
        }
        consultationTypes {
          id
          name
        }
        consultation {
          id
        }
        categories {
          id
          name
        }
      }
      case {
        id
        phase
        regimen
        artInitiationDate
        artStartDates {
          id
          startDate
          prescriptionDate
          prescriptionPeriod
          regimen
          nrti1Category {
            id
            name
          }
          nrti2Category {
            id
            name
          }
          nnrtiPiInsti {
            id
            name
          }
          additionalDrugs {
            id
            name
          }
        }
        caseId
        adminNotes
        isARTClient
        caseWorker {
          id
          firstName
          lastName
        }
        nurse {
          id
          firstName
          lastName
        }
        peopleProfile {
          id
          firstName
          lastName
          name
          dateOfBirth
          age
          contactNumber
          whatsAppNumber
          identificationType
          nationalID
          passport
          whatsAppOptIn
          emailAddress
          consentToUseInformation
          physicalAddress
          streetNo
          streetName
          townshipVillageSuburb
          townCity
          postalCode
          alternativeAddress
          nextOfKinName
          nextOfKinSurname
          nextOfKinContactNumber
          nextOfKinAlternateContactNumber
          nonClient
          nonCommunicableDiseases
          householdId
          applicableNcds
          maternalAndChildHealth
          childNutrition
          maternalStage
          isARTTransferIn
          artTransferInDate
          tb
          allergiesPresent
          allergyDetails
          homeLanguage {
            id
            name
          }
          populationGroup {
            id
            name
          }
          gender {
            id
            name
          }
          citizenship {
            id
            name
          }
          profileImage {
            id
            url
          }
        }
        appointments {
          id
          date
          time
          notes
          description
          followUpAppointment
          status
          practitioner {
            id
            firstName
            lastName
          }
          consultationTypes {
            id
            name
          }
          consultation {
            id
          }
          categories {
            id
            name
          }
        }
        consultations {
          id
          seenBy {
            id
            firstName
            lastName
          }
          activity {
            id
            name
          }
          categoryResponses {
            id
            cardType
            value
            serviceCategory {
              id
              name
            }
          }
          issue
          date
          time
          treatedBefore
          status
          rxFilled
          rx
          allergiesPresent
          allergyDetails
          routineTreatments {
            id
            prescriptionDate
            vitaminA
            mebendazole
            nextPrescriptionDate
          }
        }
        immunisation {
          bcg
          opv0
          daptIpvHbHib1
          opv1
          pcv1
          rv1
          daptIpvHbHib2
          daptIpvHbHib3
          rv2
          pcv2
          measles1
          pcv3
          measles2
          daptIpvHbHib4
          td6Years
          td12Years
          hpv
          immunisationStatus
          nextImmunisationDate
        }
      }
      categoryResponses {
        id
        cardType
        value
        serviceCategory {
          id
          name
        }
      }
      serviceResponses {
        id
        cardType
        value
        serviceCategory {
          id
          name
        }
        service {
          id
          name
        }
      }
    }
  }
`;

export const GET_CONSULTATIONS = gql`
  query GetConsultations($input: GetConsultationsInput) {
    consultations: getConsultations(input: $input) {
      aggregate {
        count
      }
      edges {
        node {
          id
          date
          time
          seenBy {
            id
            firstName
            lastName
          }
          treatedBefore
          status
          activity {
            id
            name
          }
          case {
            id
            caseId
            appointments {
              id
              consultationTypes {
                id
                name
              }
              consultation {
                id
              }
            }
            peopleProfile {
              id
              firstName
              lastName
              dateOfBirth
              age
              gender {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;
